export default {
  date: 'September 25, 2023',
  title: 'Top 3 questions of real estate developers sales process',
  description: 'Real estate developers face three critical challenges in their quest for success:',
  id: 'top-3-questions-of-real-estate-developers-sales-process',
  jsx: () => (
    <div class='novelty__text'>
      <p>1. How do I sell all my properties as quickly as possible?</p>
      <p>2. How do you figure out who to delegate sales to if you can't do it yourself?</p>
      <p>3. How do you get qualified leads to accelerate sales?</p>
      <p>These questions keep developers up at night, and their primary metric for success? It's all about speed!</p>
      <p>According to our survey, a whopping 76% of participants chose speed as the top metric in the real estate sales process. Speed matters in every aspect, from swiftly gathering information, creating compelling visuals, to sealing the deal.</p>
      <p>The solution is clear: Give developers the tools they need to accelerate the process, and you'll have them hooked. Speed is the name of the game, and in the fast-paced world of real estate, those who can keep up are the ones who win.</p>
    </div>
  ),
  thumb: 'news/1.webp',
};
